"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var CalendarPart_1 = tslib_1.__importDefault(require("./CalendarPart"));
var controlled_1 = require("../form/controlled");
var CalendarTable_1 = require("./CalendarTable");
var i18n_1 = require("../i18n");
var merge_event_props_1 = require("../_util/merge-event-props");
exports.Calendar = react_1.default.forwardRef(function Calendar(props, ref) {
    i18n_1.useTranslation(moment_1.default);
    var _a = controlled_1.useDefaultValue(props), className = _a.className, style = _a.style, restProps = tslib_1.__rest(_a, ["className", "style"]);
    var _b = tslib_1.__read(react_1.useState("date"), 2), type = _b[0], setType = _b[1];
    var value = props.value;
    var _c = tslib_1.__read(react_1.useState(moment_1.default.isMoment(value) ? value : moment_1.default()), 2), curViewMoment = _c[0], setCurViewMoment = _c[1];
    return (react_1.default.createElement(CalendarPart_1.default.Panel, tslib_1.__assign({ ref: ref, className: className, style: style }, merge_event_props_1.mergeEventProps(props)),
        react_1.default.createElement(CalendarPart_1.default.Body, null,
            react_1.default.createElement(CalendarTable_1.CalendarTable, tslib_1.__assign({}, restProps, { curViewMoment: curViewMoment, onCurViewMomentChange: setCurViewMoment, type: type, onTypeChange: setType })))));
});
exports.Calendar.displayName = "Calendar";
//# sourceMappingURL=Calendar.js.map